import { useEffect, useState } from 'react';

const useSavedFilterTimelineStartsOn = (
  filter: SavedFilter | DefaultDatasetFilter | undefined,
) => {
  const [timelineStartsOn, setTimelineStartsOn] = useState<string | undefined>(
    filter ? filter.createdOn : undefined,
  );

  useEffect(() => {
    setTimelineStartsOn(filter ? filter.createdOn : undefined);
  }, [filter]);

  return timelineStartsOn;
};

export default useSavedFilterTimelineStartsOn;
